import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../api';

export default function Timesheets() {
  const [timesheets, setTimesheets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api('/me').then(r => r.ok ? r.json() : null).then(user => {
      if (user && user.userId) {
        api('/hcm/employees?q=' + encodeURIComponent(user.userId)).then(r => r.ok ? r.json() : []).then(employees => {
          const emp = employees.find(e => e.userId === user.userId);
          if (emp) {
            api('/timesheets/timesheets?employeeId=' + emp.id).then(r => r.ok ? r.json() : []).then(setTimesheets);
          }
          setLoading(false);
        }).catch(() => setLoading(false));
      } else {
        setLoading(false);
      }
    }).catch(() => setLoading(false));
  }, []);


  if (loading) {
    return (
      <Layout>
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Timesheets</h2>

      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Period</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Total Hours</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {timesheets.map(ts => (
              <tr key={ts.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">
                  <Link to={`/timesheets/${ts.id}`} className="text-indigo-600 hover:text-indigo-800 font-medium">
                    {ts.startDate} — {ts.endDate}
                  </Link>
                </td>
                <td className="px-6 py-4">
                  <span className={`inline-flex px-2 py-1 rounded text-xs font-medium ${
                    ts.status === 'APPROVED' ? 'bg-green-50 text-green-700' :
                    ts.status === 'SUBMITTED' ? 'bg-blue-50 text-blue-700' :
                    'bg-gray-100 text-gray-600'
                  }`}>{ts.status}</span>
                </td>
                <td className="px-6 py-4 text-gray-600">{ts.totalHours != null ? Number(ts.totalHours).toFixed(2) : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {timesheets.length === 0 && <div className="text-center py-12 text-gray-500">No timesheets found.</div>}
      </div>
    </Layout>
  );
}
